// src/v3/ui/backtester/charts/drawdown.tsx

import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

interface DrawdownPoint {
  date: string;
  drawdownPct: number;
}

export function DrawdownChart({ data }: { data: DrawdownPoint[] }) {
  if (data.length === 0) {
    return (
      <div className="flex h-64 items-center justify-center text-sm text-muted-foreground">
        No drawdown data
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={260}>
      <AreaChart data={data} margin={{ top: 8, right: 16, bottom: 8, left: 8 }}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
        <XAxis
          dataKey="date"
          tick={{ fontSize: 11 }}
          className="text-muted-foreground"
        />
        <YAxis
          tick={{ fontSize: 11 }}
          className="text-muted-foreground"
          tickFormatter={(v: number) => `${v.toFixed(1)}%`}
        />
        <Tooltip
          formatter={(v) => [`${Number(v).toFixed(2)}%`, "Drawdown"]}
          contentStyle={{ fontSize: "12px" }}
        />
        <Area
          type="monotone"
          dataKey="drawdownPct"
          stroke="hsl(0 84.2% 60.2%)"
          fill="hsl(0 84.2% 60.2% / 0.15)"
          strokeWidth={2}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
